// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7a7f578b","488":"cf953022","977":"f033df6c"}[chunkId] + ".chunk.js";
};